import { c as _c } from "react/compiler-runtime";
import { Table, TableBody, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { buildComparisonTableJsonLd } from "@/lib/comparison-table-jsonld";
import { getEntryOfContentType, isEntryOfContentType } from "@/lib/contentful/guards";
import type { TypeButton, TypeComparisonTable, TypeComparisonTableColumnHeader, TypeComparisonTableRow, TypeComparisonTableValue, TypeExternalButton } from "@/types/contentful/generated";
import CTAButtonPersonalized, { type CtaExposures } from "../CtaButton/CTAButtonPersonalized";
import { JsonLd } from "../JsonLd";
import ComparisonTableColumnHeader from "./ComparisonTableColumnHeader";
import ComparisonTableRow from "./ComparisonTableRow";
type Props = TypeComparisonTable<undefined, string>["fields"] & {
  ctaExposures?: CtaExposures;
};
export type ColumnHeaderEntry = TypeComparisonTableColumnHeader<undefined, string>;
export type RowEntry = TypeComparisonTableRow<undefined, string>;
export type ValueEntry = TypeComparisonTableValue<undefined, string>;
export default function ComparisonTable(t0) {
  const $ = _c(66);
  const {
    title,
    subtitle,
    type,
    columnHeaders,
    rows,
    cta,
    ctaExposures,
    anchor
  } = t0;
  let T0;
  let T1;
  let ctaEntry;
  let t1;
  let t10;
  let t11;
  let t12;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== anchor || $[1] !== columnHeaders || $[2] !== cta || $[3] !== rows || $[4] !== subtitle || $[5] !== title || $[6] !== type) {
    t12 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const resolvedColumnHeaders = columnHeaders.filter(_temp);
      const columnOrder = resolvedColumnHeaders.map(_temp2);
      const resolvedRows = rows.filter(_temp3);
      const tableMinWidth = `${224 + resolvedColumnHeaders.length * 200}px`;
      let t13;
      if ($[22] !== cta) {
        t13 = getEntryOfContentType(cta, "button");
        $[22] = cta;
        $[23] = t13;
      } else {
        t13 = $[23];
      }
      const intCta = t13;
      let t14;
      if ($[24] !== cta) {
        t14 = getEntryOfContentType(cta, "externalButton");
        $[24] = cta;
        $[25] = t14;
      } else {
        t14 = $[25];
      }
      const extCta = t14;
      ctaEntry = intCta ?? extCta;
      const comparisonTableJsonLd = buildComparisonTableJsonLd({
        type,
        title,
        subtitle,
        columnHeaders: resolvedColumnHeaders,
        rows: resolvedRows
      });
      if (resolvedRows.length === 0) {
        t12 = null;
        break bb0;
      }
      t8 = "max-w-site-content w-full mx-auto p-6";
      if ($[26] !== anchor) {
        t9 = anchor ? {
          id: anchor
        } : {};
        $[26] = anchor;
        $[27] = t9;
      } else {
        t9 = $[27];
      }
      t10 = <JsonLd data={comparisonTableJsonLd} />;
      let t15;
      if ($[28] !== title) {
        t15 = title && <h1 className="text-4xl">{title}</h1>;
        $[28] = title;
        $[29] = t15;
      } else {
        t15 = $[29];
      }
      let t16;
      if ($[30] !== subtitle) {
        t16 = subtitle && <h2 className="text-xl heading-xs">{subtitle}</h2>;
        $[30] = subtitle;
        $[31] = t16;
      } else {
        t16 = $[31];
      }
      if ($[32] !== t15 || $[33] !== t16) {
        t11 = <div className="mb-6">{t15}{t16}</div>;
        $[32] = t15;
        $[33] = t16;
        $[34] = t11;
      } else {
        t11 = $[34];
      }
      t7 = "border border-border rounded-lg shadow-md overflow-hidden";
      t6 = "*:data-[slot=table-container]:overflow-x-auto *:data-[slot=table-container]:overflow-y-hidden";
      T1 = Table;
      t2 = "table-fixed";
      if ($[35] !== tableMinWidth) {
        t3 = {
          minWidth: tableMinWidth
        };
        $[35] = tableMinWidth;
        $[36] = t3;
      } else {
        t3 = $[36];
      }
      let t17;
      if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = <col className="w-56" />;
        $[37] = t17;
      } else {
        t17 = $[37];
      }
      t4 = <colgroup>{t17}{resolvedColumnHeaders.map(_temp4)}</colgroup>;
      const t18 = resolvedColumnHeaders.length > 0 && <TableRow className="border-b border-border"><TableHead />{resolvedColumnHeaders.map(_temp5)}</TableRow>;
      if ($[38] !== t18) {
        t5 = <TableHeader>{t18}</TableHeader>;
        $[38] = t18;
        $[39] = t5;
      } else {
        t5 = $[39];
      }
      T0 = TableBody;
      t1 = resolvedRows.map(row_0 => <ComparisonTableRow key={row_0.sys.id} row={row_0} columnOrder={columnOrder} />);
    }
    $[0] = anchor;
    $[1] = columnHeaders;
    $[2] = cta;
    $[3] = rows;
    $[4] = subtitle;
    $[5] = title;
    $[6] = type;
    $[7] = T0;
    $[8] = T1;
    $[9] = ctaEntry;
    $[10] = t1;
    $[11] = t10;
    $[12] = t11;
    $[13] = t12;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    T0 = $[7];
    T1 = $[8];
    ctaEntry = $[9];
    t1 = $[10];
    t10 = $[11];
    t11 = $[12];
    t12 = $[13];
    t2 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  if (t12 !== Symbol.for("react.early_return_sentinel")) {
    return t12;
  }
  let t13;
  if ($[40] !== T0 || $[41] !== t1) {
    t13 = <T0>{t1}</T0>;
    $[40] = T0;
    $[41] = t1;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== T1 || $[44] !== t13 || $[45] !== t2 || $[46] !== t3 || $[47] !== t4 || $[48] !== t5) {
    t14 = <T1 className={t2} style={t3}>{t4}{t5}{t13}</T1>;
    $[43] = T1;
    $[44] = t13;
    $[45] = t2;
    $[46] = t3;
    $[47] = t4;
    $[48] = t5;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== t14 || $[51] !== t6) {
    t15 = <div className={t6}>{t14}</div>;
    $[50] = t14;
    $[51] = t6;
    $[52] = t15;
  } else {
    t15 = $[52];
  }
  let t16;
  if ($[53] !== ctaEntry || $[54] !== ctaExposures) {
    t16 = ctaEntry && <div className="px-4 py-6 border-t border-border"><CTAButtonPersonalized entry={ctaEntry} exposures={ctaExposures?.[ctaEntry.sys.id]} /></div>;
    $[53] = ctaEntry;
    $[54] = ctaExposures;
    $[55] = t16;
  } else {
    t16 = $[55];
  }
  let t17;
  if ($[56] !== t15 || $[57] !== t16 || $[58] !== t7) {
    t17 = <div className={t7}>{t15}{t16}</div>;
    $[56] = t15;
    $[57] = t16;
    $[58] = t7;
    $[59] = t17;
  } else {
    t17 = $[59];
  }
  let t18;
  if ($[60] !== t10 || $[61] !== t11 || $[62] !== t17 || $[63] !== t8 || $[64] !== t9) {
    t18 = <div className={t8} {...t9}>{t10}{t11}{t17}</div>;
    $[60] = t10;
    $[61] = t11;
    $[62] = t17;
    $[63] = t8;
    $[64] = t9;
    $[65] = t18;
  } else {
    t18 = $[65];
  }
  return t18;
}
function _temp5(column_2) {
  return <ComparisonTableColumnHeader key={column_2.sys.id} columnHeaderEntry={column_2} />;
}
function _temp4(column_1) {
  return <col key={column_1.sys.id} className="w-50" />;
}
function _temp3(row) {
  return isEntryOfContentType(row, "comparisonTableRow");
}
function _temp2(column_0) {
  return column_0.sys.id;
}
function _temp(column) {
  return isEntryOfContentType(column, "comparisonTableColumnHeader");
}